import i18n, { SIGNUP_NAMESPACE } from '@/i18n';
import { stripCpfDigits } from '@/Pages/Signup/utils/cpfMask';

const CPF_LENGTH = 11;

function calculateCheckDigit(digits: number[], weights: number[]): number {
  const sum = digits.reduce((total, digit, index) => total + digit * weights[index], 0);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

function hasValidCheckDigits(digits: number[]): boolean {
  const firstCheck = calculateCheckDigit(digits.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (firstCheck !== digits[9]) {
    return false;
  }
  const secondCheck = calculateCheckDigit(digits.slice(0, 10), [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
  return secondCheck === digits[10];
}

function hasRepeatedDigits(digits: string): boolean {
  return /^(\d)\1{10}$/.test(digits);
}

export function isValidCpf(value: string): boolean {
  const digits = stripCpfDigits(value);
  if (digits.length !== CPF_LENGTH) {
    return false;
  }
  if (hasRepeatedDigits(digits)) {
    return false;
  }
  const numericDigits = digits.split('').map(Number);
  return hasValidCheckDigits(numericDigits);
}

export function getCpfInvalidMessage(): string {
  return i18n.t('validation.cpfInvalid', { ns: SIGNUP_NAMESPACE });
}

export const CPF_INVALID_MESSAGE = getCpfInvalidMessage();

export function validateCpf(
  value: string,
): { valid: true } | { valid: false; message: string } {
  if (isValidCpf(value)) {
    return { valid: true };
  }
  return { valid: false, message: getCpfInvalidMessage() };
}
